import React, { useEffect, useState } from "react";
import { ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { fetchCheckInHistory } from "../services/checkInApi";
import "./HistorySectionDashBoard.css";

const HistorySectionDashBoard = ({ showTitle = true }) => {
  const navigate = useNavigate();

  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const loadHistory = async () => {
      try {
        setLoading(true);
        setError("");

        const data = await fetchCheckInHistory();
        setHistory(data);
      } catch (err) {
        console.error(err);
        setError(err.message || "Failed to load check-in history.");
      } finally {
        setLoading(false);
      }
    };

    loadHistory();
  }, []);

  const handleOpenDetail = (resultId) => {
    navigate(`/check-in/history/${resultId}`);
  };

  if (loading) {
    return (
      <section className="history-section">
        <p className="history-loading">Loading your history...</p>
      </section>
    );
  }

  return (
    <section className="history-section">
      {showTitle && <h2 className="history-title">Check-in history</h2>}

      {error && (
        <p className="history-error" role="alert">
          {error}
        </p>
      )}

      {!error && history.length === 0 ? (
        <div className="history-empty">
          <p>No check-in records yet.</p>
        </div>
      ) : (
        <div className="history-list"> 
          {history.slice(0, 10).map((item) => (  // maximun numbers of cards are 10
            <button
              key={item.id}
              type="button"
              className="history-card history-card--clickable"
              onClick={() => handleOpenDetail(item.id)}
            >
              <div className="history-top">
                <div>
                  <span
                    className={`risk-badge risk-${item.risk_level.toLowerCase()}`}
                  >
                    {item.risk_level} risk
                  </span>
                  <p className="history-date">
                    {new Date(item.created_at).toLocaleString()}
                  </p>
                </div>

                <div className="history-card__right">
                  <span className="history-score">
                    {item.total_score}
                    <span>Score</span>
                  </span>
                  <ChevronRight className="history-card__chevron" aria-hidden="true" />
                </div>
              </div>
            </button>
          ))}
        </div>
      )}
    </section>
  );
};

export default HistorySectionDashBoard;
